import { redactConsoleArgs, redactUrl } from './redact';

const CONSOLE_CAPACITY = 100;
const NETWORK_CAPACITY = 50;

const consoleBuffer = [];
const networkBuffer = [];
let initialised = false;

function pushRing(buffer, capacity, item) {
  buffer.push(item);
  if (buffer.length > capacity) buffer.splice(0, buffer.length - capacity);
}

const LEVELS = ['log', 'info', 'warn', 'error', 'debug'];

export function initDiagnostics() {
  if (initialised || typeof window === 'undefined') return;
  initialised = true;
  for (const level of LEVELS) {
    const original = console[level];
    if (typeof original !== 'function') continue;
    console[level] = (...args) => {
      try {
        pushRing(consoleBuffer, CONSOLE_CAPACITY, {
          ts: new Date().toISOString(),
          level,
          args: redactConsoleArgs(args)
        });
      } catch {
        // never let our wrapper break logging
      }
      return original.apply(console, args);
    };
  }
}

export function pushNetwork({ method, url, status, durationMs }) {
  pushRing(networkBuffer, NETWORK_CAPACITY, {
    ts: new Date().toISOString(),
    method: String(method || '').toUpperCase(),
    url: redactUrl(url),
    status: Number.isFinite(status) ? status : null,
    durationMs: Number.isFinite(durationMs) ? Math.round(durationMs) : null
  });
}

export function getDiagnosticsSnapshot() {
  return {
    console: consoleBuffer.slice(),
    network: networkBuffer.slice()
  };
}

export function clearDiagnostics() {
  consoleBuffer.length = 0;
  networkBuffer.length = 0;
}
